<script setup lang="tsx">
import { useI18n } from 'vue-i18n'
import HeaderComponent from '../shared/HeaderComponent.vue'
import ModuleTable from './ModuleTable.vue'
import IconButton from '../shared/IconButton.vue'
import sliderStore from '@/stores/slider'
import { hasPermission } from '@/services/utils'
import { PermModuleAdd } from '@/models/enums-generated'

const slider = sliderStore()

const { t } = useI18n()
</script>

<template>
	<HeaderComponent :title="$t('module.label')">
		<template #right-side>
			<IconButton
				v-if="hasPermission(PermModuleAdd)"
				data-test="open-new-module"
				:title="t('misc.add')"
				class="bi bi-plus-square"
				@click="slider.openAddModule"
			/>
		</template>
	</HeaderComponent>
	<ModuleTable></ModuleTable>
</template>
